import * as userRequest from "@/utils/userRequest";

export default async function comfirmOTPValidateService(
    token: string,
    otp: string,
    type: string,
    totp?: string,
    onSuccess?: (data?: any) => any,
    handleError?: (err?: any) => any,
    deviceId?: string
) {
    try {
        const res = await userRequest.post(
            "auth/confirm-otp-validate",
            {
                otp,
                totp,
                type,
                deviceId,
            },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        if (res) {
            onSuccess && onSuccess(res);
            return res;
        }
    } catch (err) {
        console.error("🚀 ~ comfirmOTPValidateService ~ err:", err);
        handleError && handleError(err);
        throw err;
    }
}
